import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChangeHistoryPage } from './change-history';
import { ChangeHistoryComponent } from '../change-history-component/change-history-component';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    ChangeHistoryPage,
    ChangeHistoryComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(ChangeHistoryPage),
    GridModule,
    RowFilterModule,
  ],
})
export class ChangeHistoryPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/change-history/change-history/change-history.module.ts